import {
  AfterContentInit,
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';
import { PlatformEnum } from '@panamax/app-state';

@Component({
  selector: 'app-search-bar-multi-line',
  templateUrl: './search-bar-multi-line.component.html',
  styleUrls: ['./search-bar-multi-line.component.scss'],
})
export class SearchBarMultiLineComponent implements OnInit {
  searchKey = '';
  isSmallSearch = true;

  @Input() formatSearch: Function;
  @Input() placeholderSearch: string;
  @Input() platform: PlatformEnum;
  @Input() blockFormatting = false;

  @Output() inputEmitter: EventEmitter<void> = new EventEmitter();
  @Output() pasteEmitter: EventEmitter<string> = new EventEmitter();
  @Output() searchEmitter: EventEmitter<string> = new EventEmitter();
  @Output() resetSearchEmitter: EventEmitter<void> = new EventEmitter();
  constructor() {}

  ngOnInit() {
    this.searchKey = '';
    this.isSmallSearch = true;
  }

  executeSearch($event) {
    $event.preventDefault();
    if (this.formatSearch && !this.blockFormatting) {
      this.searchKey = this.formatSearch(this.searchKey);
    }
    this.judgeSearchSize();
    this.searchEmitter.emit(this.searchKey);
  }

  resetSearch() {
    this.searchKey = '';
    this.judgeSearchSize();
    this.resetSearchEmitter.emit();
  }

  onPaste() {
    setTimeout(() => {
      if (this.formatSearch) {
        this.searchKey = this.formatSearch(this.searchKey);
      }
      this.judgeSearchSize();
      this.pasteEmitter.emit(this.searchKey);
    }, 0);
  }

  judgeSearchSize() {
    const lengthforSearchBar = document.getElementById('search-container')
      .clientWidth;
    const documentRuler = document.createElement(`div`);
    documentRuler.textContent = this.searchKey;
    documentRuler.style.setProperty('position', 'absolute');
    documentRuler.style.setProperty('float', 'left');
    documentRuler.style.setProperty('white-space', 'nowrap');
    documentRuler.style.setProperty('visibility', 'hidden');
    documentRuler.style.setProperty('fontSize', '0.75rem');
    documentRuler.style.setProperty('fontFamily', 'SF Pro Regular');
    document.body.appendChild(documentRuler);
    const widthOfText = documentRuler.clientWidth;
    documentRuler.remove();
    if (
      widthOfText >=
      lengthforSearchBar * (this.platform === PlatformEnum.mobile ? 1 : 1.2)
    ) {
      this.isSmallSearch = false;
    } else {
      this.isSmallSearch = true;
    }
  }

  onIonInput() {
    this.inputEmitter.emit();
    this.judgeSearchSize();
  }
}
